module.exports = __webpack_public_path__ + "MoneyPig-89PtWH8.svg";